import * as model from './model';

export const firebaseEntity = { model };
export type { MaintenanceToasterConfig, AppRemoteConfig } from './types';
